import React, { Fragment, useState } from "react";
import { Card, CardBody, Col, Container, Media, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { makeStyles } from "@mui/styles";
import CommonTable from "../../common/commonTable";

import CommonLoader from "../../common/commonLoader";
import { formatMoney } from "../../../constants/utils";
import {
  agingReportFutureODData,
  agingReportFutureODHeader,
  agingReportFutureODProvRegionDetail,
  agingReportFutureODProvRegionHeader,
  agingReportFutureODProvStateDetail,
  agingReportFutureODProvStateHeader,
} from "../../common/commonConstant";
import FutureOverdueAsmInputModal from "./futureOverdueAsmInputModal";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import CommonTableWithFooterFixed from "../../common/commonTableWithFooterFixed";
import FutureOverdueProvPartywiseModal from "./futureOverdueProvPartywiseModal";
import { Bar } from "react-chartjs-2";
import Chart from "react-google-charts";

const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },

  btnJust: {
    display: "flex!important",
    justifyContent: "end!important",
  },

  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },

  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

const status = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Approved",
    label: "Approved",
  },
  {
    value: "Reject",
    label: "Reject",
  },
];

const AgeingReportFutureOD = (props) => {
  const {
    futureODList,
    futureODProvListByRegion,
    futureODProvListByState,
    futureODProvListByRegionPartyWise,
    futureODProvListByStatePartyWise,
  } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [customerRowData, setCustomerRowData] = useState({});
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState({});
  const [title, setTitle] = useState("");
  const [listData, setListData] = useState([]);

  const onOpenModalState = (row) => {
    setRowData(row);
    if (row.stateMasterId > 0) {
      const filteredData = futureODProvListByStatePartyWise.filter(
        (item) => item.stateMasterId === row.stateMasterId
      );
      setListData(filteredData);
    } else {
      setListData(futureODProvListByStatePartyWise);
    }
    setTitle(
      (row.stateMasterId > 0 ? row.stateName : "All") +
        " Future OD/Prov. Details"
    );
    setOpen(true);
  };
  const onOpenModalRegion = (row) => {
    setRowData(row);
    if (row.regionMasterId > 0) {
      const filteredData = futureODProvListByRegionPartyWise.filter(
        (item) => item.regionMasterId === row.regionMasterId
      );
      setListData(filteredData);
    } else {
      setListData(futureODProvListByRegionPartyWise);
    }
    setTitle(
      (row.regionMasterId > 0 ? row.regionName : "All") +
        " Future OD/Prov. Details"
    );
    setOpen(true);
  };

  const [activeTab, setActiveTab] = useState("1");
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // REGION CHART STARTS
  const futureODProvListByRegionWithoutTotal = futureODProvListByRegion.filter(
    ({ regionName }) => regionName?.toLowerCase() !== "total"
  );

  const labels = futureODProvListByRegionWithoutTotal.map(
    (item) => item.regionName
  );

  const barChartDataByDataRegion = {
    labels,
    datasets: [
      {
        label: "Live Overdue",
        data: futureODProvListByRegionWithoutTotal.map(
          (item) => item.liveOverdue
        ),
        borderColor: "#da0000",
        backgroundColor: "#da0000",
        //backgroundColor: "rgb(218, 0, 0)",
        borderWidth: 2,
      },
      {
        label: "Live Provision",
        data: futureODProvListByRegionWithoutTotal.map(
          (item) => item.liveProvision
        ),
        borderColor: "#d69e11",
        backgroundColor: "#d69e11",
        //backgroundColor: "rgb(218, 0, 0)",
        borderWidth: 2,
      },
      {
        label: "Future Overdue",
        data: futureODProvListByRegionWithoutTotal.map(
          (item) => item.futureOverdue
        ),
        borderColor: "#0400da",
        backgroundColor: "#0400da",
        borderWidth: 2,
      },
      {
        label: "Future Provision",
        data: futureODProvListByRegionWithoutTotal.map(
          (item) => item.futureProvision
        ),
        borderColor: "#c8da00",
        backgroundColor: "#c8da00",
        borderWidth: 2,
      },
    ],
  };

  const barChartDataByRegionOptions = {
    maintainAspectRatio: false,
    responsive: true,

    animation: true,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      xAxes: {
        barPercentage: 0.7,
        categoryPercentage: 0.4,
        gridLines: {
          display: false,
        },
      },
      yAxes: {
        barPercentage: 0.7,
        categoryPercentage: 0.4,
      },
    },
    /* scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    }, */
  };
  // REGION CHART ENDS

  //STATE WISE CHART STARTS

  // 27 unique background colors
  const backgroundColors = [
    "#1a139f",
    "#ff6384",
    "#36a2eb",
    "#ffce56",
    "#4bc0c0",
    "#9966ff",
    "#ff9f40",
    "#e74c3c",
    "#2ecc71",
    "#f39c12",
    "#9b59b6",
    "#8e44ad",
    "#2c3e50",
    "#d35400",
    "#16a085",
    "#c0392b",
    "#7f8c8d",
    "#e67e22",
    "#2980b9",
    "#f1c40f",
    "#27ae60",
    "#34495e",
    "#dc7633",
    "#f1948a",
    "#5dade2",
    "#58d68d",
    "#d5dbdb",
  ];

  const pieChartData = [
    ["State", "Future Overdue"],
    ...futureODProvListByState
      .filter(({ stateName }) => stateName?.toLowerCase() !== "total") // filter out total
      .map(({ stateName, futureOverdue }) => [stateName, futureOverdue]),
  ];

  const pieOptionsForState = {
    title: "Future Overdue by State",
    titleTextStyle: { fontSize: 16, bold: true }, // Customize title style
    pieHole: 0.4, // Semi-donut effect
    slices: futureODProvListByState.map((_, index) => ({
      color: backgroundColors[index],
    })),
    tooltip: { showColorCode: true },
    chartArea: { left: 10, top: 10, width: "100%", height: "100%" },
    //legend: { position: "right" },
    legend: "none", // Hides the legend
    width: 400, // adjust width
    height: 400, // adjust height
    //legend: { position: "right" },
  };

  const pieChartDataForStateFutureProvision = [
    ["State", "Future Overdue"],
    ...futureODProvListByState
      .filter(({ stateName }) => stateName?.toLowerCase() !== "total") // filter out total
      .map(({ stateName, futureProvision }) => [stateName, futureProvision]),
  ];

  const pieOptionsForStateFutureProvision = {
    title: "Future Overdue by State",
    titleTextStyle: { fontSize: 16, bold: true }, // Customize title style
    pieHole: 0.4, // Semi-donut effect
    slices: futureODProvListByState.map((_, index) => ({
      color: backgroundColors[index],
    })),
    tooltip: { showColorCode: true },
    chartArea: { left: 10, top: 10, width: "100%", height: "100%" },
    //legend: { position: "right" },
    legend: "none", // Hides the legend
    width: 400, // adjust width
    height: 400, // adjust height
    //legend: { position: "right" },
  };

  //STATE WISE CHART ENDS

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <TabContext value={activeTab}>
          <TabList
            onChange={handleTabChange}
            aria-label="lab API tabs example"
            indicatorColor="secondary"
            textColor="secondary"
            style={{ background: "white" }}
          >
            <Tab label="By Region" value="1" />
            <Tab label="By State" value="2" />
          </TabList>
          {/* By Region Section Starts*/}
          <TabPanel value="1">
            <Card>
              <CardBody className={classes.cardbody}></CardBody>
            </Card>
            <div className="market-chart">
              <Bar
                data={barChartDataByDataRegion}
                options={barChartDataByRegionOptions}
                width={778}
                height={308}
              />
            </div>
            <CommonTableWithFooterFixed
              tableData={futureODProvListByRegion.filter(
                ({ regionName }) => regionName?.toLowerCase() !== "total"
              )}
              tableHeaders={agingReportFutureODProvRegionHeader}
              tableColumns={agingReportFutureODProvRegionDetail}
              editId={"regionMasterId"}
              editMode={true}
              onOpenModal={onOpenModalRegion}
              rowsPerPageOptions={[25, 50, 100]}
              count={futureODProvListByRegion.length}
              sx={{ float: "right" }}
              displayPagination={false}
              tableFooterData={futureODProvListByRegion.filter(
                ({ regionName }) => regionName?.toLowerCase() === "total"
              )}
            />
          </TabPanel>
          <TabPanel value="2">
            <Card>
              <CardBody style={{ padding: "2px" }}>
                <Row>
                  <Col xl="4" lg="4" md="4" sm="12">
                    <h5>Future Overdue</h5>
                    <div className="d-flex justify-content-center order-graph sm-order-space">
                      <div className="peity-chart-dashboard text-center">
                        <Chart
                          chartType="PieChart"
                          data={pieChartData}
                          options={pieOptionsForState}
                          graph_id="PieChart"
                          width={"400px"} // Increase width
                          height={"400px"}
                          //legend_toggle
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xl="8" lg="8" md="8" sm="12">
                    <Row>
                      <Col xl="6" sm="12" style={{ paddingLeft: 50 }}>
                        {" "}
                        <div className="order-graph sm-order-space">
                          <Media body>
                            <h6 className="mb-0 me-0">
                              {`State`}
                              <span className="pull-right">{`Overdue`}</span>
                            </h6>
                          </Media>
                          <div
                            className="order-graph-bottom sales-location"
                            style={{ height: 440, overflow: "scroll" }}
                          >
                            {futureODProvListByState
                              .filter(
                                ({ stateName }) =>
                                  stateName?.toLowerCase() !== "total"
                              ) // filter out total
                              .slice(0, 13)
                              .map((item, index) => {
                                return (
                                  <Media>
                                    <div
                                      className="order-shape-primary"
                                      style={{
                                        backgroundColor:
                                          backgroundColors[index],
                                      }}
                                    ></div>
                                    <Media body>
                                      <h6 className="mb-0 me-0">
                                        {`${item.stateName} `}
                                        <span className="pull-right">
                                          {formatMoney(item.futureOverdue)}
                                        </span>
                                      </h6>
                                    </Media>
                                  </Media>
                                );
                              })}
                          </div>
                        </div>
                      </Col>
                      {futureODProvListByState.length > 13 && (
                        <Col
                          xl="6"
                          sm="12"
                          //style={{ height: 500, overflow: "scroll" }}
                        >
                          {" "}
                          <div className="order-graph sm-order-space">
                            <Media body>
                              <h6 className="mb-0 me-0">
                                {`State`}
                                <span className="pull-right">{`Overdue`}</span>
                              </h6>
                            </Media>
                            <div
                              className="order-graph-bottom sales-location"
                              style={{ height: 440, overflow: "scroll" }}
                            >
                              {futureODProvListByState
                                .filter(
                                  ({ stateName }) =>
                                    stateName?.toLowerCase() !== "total"
                                ) // filter out total
                                .slice(13)
                                .map((item, index) => {
                                  return (
                                    <Media>
                                      <div
                                        className="order-shape-primary"
                                        style={{
                                          backgroundColor:
                                            backgroundColors[index + 14],
                                        }}
                                      ></div>
                                      <Media body>
                                        <h6 className="mb-0 me-0">
                                          {`${item.stateName} `}
                                          <span className="pull-right">
                                            {formatMoney(item.futureOverdue)}
                                          </span>
                                        </h6>
                                      </Media>
                                    </Media>
                                  );
                                })}
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  {/* <Col xl="6" lg="6" md="6" sm="12">
                    <h5>Future Provision</h5>
                    <div className="d-flex justify-content-center order-graph sm-order-space">
                      <div className="peity-chart-dashboard text-center">
                        <Chart
                          chartType="PieChart"
                          data={pieChartDataForStateFutureProvision}
                          options={pieOptionsForStateFutureProvision}
                          graph_id="PieChart"
                          width={"400px"} // Increase width
                          height={"400px"}
                          //legend_toggle
                        />
                      </div>
                    </div>
                  </Col> */}
                </Row>
              </CardBody>
            </Card>
            <CommonTableWithFooterFixed
              tableData={futureODProvListByState.filter(
                ({ stateName }) => stateName?.toLowerCase() !== "total"
              )}
              tableHeaders={agingReportFutureODProvStateHeader}
              tableColumns={agingReportFutureODProvStateDetail}
              editId={"stateMasterId"}
              editMode={true}
              onOpenModal={onOpenModalState}
              rowsPerPageOptions={[25, 50, 100]}
              count={futureODProvListByState.length}
              sx={{ float: "right" }}
              displayPagination={false}
              tableFooterData={futureODProvListByState.filter(
                ({ stateName }) => stateName?.toLowerCase() === "total"
              )}
            />
          </TabPanel>
        </TabContext>
        {/*  <Row>
          <CardBody className={classes.cardbody}>
            <CommonTable
              tableData={futureODList}
              tableHeaders={agingReportFutureODHeader}
              tableColumns={agingReportFutureODData}
              editId={"customerCode"}
              editMode={true}
              onOpenModal={onOpenModalRegion}
              rowsPerPageOptions={[25, 50, 100]}
              count={futureODList.length}
              sx={{ float: "right" }}
              displayPagination={false}
            />
          </CardBody>
        </Row> */}
        <FutureOverdueProvPartywiseModal
          open={open}
          onCancel={() => {
            setOpen(false);
            setTitle();
            setListData([]);
          }}
          listData={listData}
          title={title}
          setOpenSaveModal={setOpenSaveModal}
          setCustomerRowData={setCustomerRowData}
        />
        <FutureOverdueAsmInputModal
          open={openSaveModal}
          onCancel={() => {
            setOpenSaveModal(false);
            setCustomerRowData(null);
          }}
          customerRowData={customerRowData}
          setCustomerRowData={setCustomerRowData}
        />
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default AgeingReportFutureOD;
